import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "PrimeSolution";
const SITE_URL = "https://primesolution.co.kr";
const DEFAULT_DESCRIPTION =
  "프라임솔루션 - SPD(서지 보호기), 피뢰침, 접지시스템, 고조파 저감장치 제조 전문업체. 전원용·통신용 서지 보호, 전력품질 솔루션 제공.";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;
const DEFAULT_KEYWORDS =
  "프라임솔루션, SPD, 서지보호기, 피뢰침, 접지시스템, 고조파저감, 전력품질, surge protection, prime solution, 서지프로텍터, 낙뢰보호";

const SEO = ({
  title = SITE_NAME,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) => {
  const canonicalUrl =
    typeof window !== "undefined" ? window.location.href : SITE_URL;

  return (
    <Helmet>
      {/* 기본 */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph (구글, 네이버, 카카오 링크 미리보기) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
